import styled, { keyframes } from 'styled-components';

const slideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const NudgeWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  background: var(--color-white);
  border: 1px solid var(--gray-light);
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  padding: 14px 24px;
  width: fit-content;
  max-width: 100%;
  margin: 1rem auto 0;
  animation: ${slideUp} 0.3s ease-out;
`;

export const NudgeText = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: var(--gray-darkest);
  white-space: nowrap;
`;

export const IconsGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const IconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: none;
  background: var(--gray-lightest);
  color: var(--brand-primary);
  cursor: pointer;
  padding: 0;
  opacity: 0.7;

  &:hover {
    opacity: 1;
  }
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--gray-darkest);
  padding: 0;
  margin-left: 8px;
  line-height: 1;
  opacity: 0.7;

  &:hover {
    opacity: 1;
  }
`;
